import { $ } from "bits/jquery"
export default {
  beforeDestroy() {
    this.destroyDraggable()
  },
  methods: {
    initializeDraggable(onMovedPostHandler) {
      this.$_draggableMixin_onMovedPostHandler = onMovedPostHandler
      this.$nextTick(()=> {
        this.$_draggableMixin_makeDraggable()
      })
    },
    destroyDraggable() {
      this.$_draggableMixin_destroyDraggable()
      this.$_draggableMixin_onMovedPostHandler = null
    },
    $_draggableMixin_savePosition(position) {
      this.$_draggableMixin_onMovedPostHandler({
        postCid: this.post.cid,
        position: position
      })
    },
    $_draggableMixin_makeDraggable() {
      let rootElement = $(this.$el)
      rootElement.draggable({
        containment: [0, 0],
        cancel: '[contenteditable], .ui-resizable-handle, object, embed, input, textarea, button, select, option',
        cursor: 'move',
        snap: '.surface-post',
        snapTolerance: 4,
        start: (event, ui) => {
          var boundingRect;
          rootElement.addClass('noclick is-moving');
          boundingRect = this.$el.parentElement.getBoundingClientRect();
          rootElement.draggable("option", "containment", [boundingRect.left, boundingRect.top]);
          rootElement.draggable("instance")._setContainment();
        },
        drag: (event, ui) => {
          jsPlumb && jsPlumb.revalidate(this.$el);
        },
        stop: (event, ui) =>  {
          setTimeout(() => {
            rootElement.removeClass('noclick is-moving');
          }, 100)
          this.$_draggableMixin_savePosition(ui.position);
        }
      });
    },
    $_draggableMixin_destroyDraggable() {
      if (!this.$el) return
      const draggableInstance = $(this.$el).off(".draggable").draggable("instance")
      if (draggableInstance) draggableInstance.destroy()
    }
  },
}